<template>
	<div class="cents">
		<van-nav-bar
		:title="$t('rygl')"
		:right-text="$t('tj')"
		left-arrow
		safe-area-inset-top
		style="background-color: #1ABC9C;"
		@click-left="goto"
		@click-right="addPerson"
		/>
		<div class="requist">
			<van-field :border="true" clearable size="large" v-model="keyword" :placeholder="$t('sbmhzwz')"/>
			<van-button color="#1ABC9C" size="small" @click='questlist'>{{$t('cx')}}</van-button>
		</div>
		<van-list
		    v-model="loading"
		    :finished="finished"
		    :finished-text="$t('mygd')"
			:loading-text="$t('加载中')"
		    @load="loadMore"
		>
			<div v-for="item in personList" :key="item.id" class="personItem">
				<img v-if="item.face_url" :src="headerImgUrl+item.face_url" class="itemImg"/>
				<img v-else src="../../images/selectfile.png" class="itemImg"/>
				<div class="itemInfoBox">
					<div class="itemInfo">
						<div class="itemName">{{item.name}}</div>
					</div>
					<div class="itemInfo">
						<div class="itemMobile" v-if="item.mobile">({{item.mobile}})</div>
					</div>
					<div class="itemInfo">
						<div class="itemDept">{{$t('bm')}}：{{item.dept_name}}</div>
					</div>
					<div class="itemInfo">
						<div>{{$t('shzt')}}：{{item.approve_state==0?$t('wsp'):item.reg_face_status==0?$t('rlwzc'):item.reg_face_status==1?$t('rlbfmzc'):item.reg_face_status==2?$t('ysh'):$t('rlzcsb')}}</div>
					</div>
				</div>
				<div class="btnBox">
					<div class="itemBtn" @click="handleEdit(item.id)">{{$t('xg')}}</div>
					<div class="itemBtnDel" @click="handleDle(item.id)">{{$t('sc')}}</div>
				</div>
			</div>
		</van-list>
		<popup :popState='popState' @popConfirm='popConfirm' @popClose='popClose' :title='$t("rysc")' :btnTxt='$t("qr")' :namePlaceholder='$t("qsryhm")' :paswodPlaceholder='$t("qsryhmm")'></popup>
	</div>
</template>

<script>
	import popup from '@/components/popupInput.vue'
	import { Toast } from 'vant';
	export default {
		data(){
			return {
				headerImgUrl:"https://web.fondcard.net/static",
				UserInfo:JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				keyword:'', // 搜索框 绑定值
				personList:[], // 人员 列表
				popState:false, // 删除弹窗 状态
				id:'', // 被点击删除人员 的 id
				loading:false,
				finished: false,
				page_index:0,
				count:null,
			}
		},
		components:{
			popup
		},
		mounted() {
			// this.getList(this.keyword)
			// this.page_index=0
		},
		watch:{
			keyword(newVal){
				if(newVal==''){
					this.personList = []
					this.finished = false;
					this.getList(this.keyword)
				}
			}
		},
		methods:{
			// 获取更多列表
			loadMore() {
				console.log('触发');
			    this.page_index++;
			    this.getList()
				console.log(this.page_index);
			},
			// 弹窗确认删除
			popConfirm(e){
				console.log(e)
				console.log(this.$md5(e[1]))
				if(e[0]==''){
					Toast.fail(this.$t('qsryhm'))
				}else if(e[1]==''){
					Toast.fail(this.$t('qsrmm'))
				}else{
					let data = {
						method:'co.person.del',
						name:e[0],
						password:this.$md5(e[1]),
						id:this.id
					}
					this.$https(data).then(res=>{
						console.log(res)
						if(res.data.code==0){
							Toast.success(this.$t('sccg'))
							this.popState=false
							this.page_index = 1
							this.personList = []
							this.finished = false
							this.getList(this.keyword)
						}else if(res.data.code==-3){
							Toast.fail(this.$t('rybcz'))
							this.popState=false
							this.getList(this.keyword)
						}else{
							Toast.fail(this.$t('myqxhzhcw'))
						}
					})
				}
			},
			// 点击遮盖层 关闭弹窗
			popClose(){
				this.popState=false
			},
			// 点击删除
			handleDle(id){
				this.id = id
				this.popState=true
			},
			// 点击修改
			handleEdit(id){
				this.$router.push(`/admin/personEdit?id=`+id)
			},
			// 点击查询
			questlist(){
				this.page_index=1
				this.personList = []
				this.getList(this.keyword)
				// this.page_index=0
			},
			// 获取人员列表
			getList(name){
				let data = {
					method:'co.person.list',
					page_index:this.page_index,
					page_size:10,
					name:name,
					mobile:'',
					card_no:'',
					agent_id:this.UserInfo.agent_id,
					dept_id:-1,
					number:'',
					manager_id:this.UserInfo.manager_id,
					order_by:0
				}
				this.$https(data).then(res=>{
					console.log(res)
					// this.personList = res.data.data
					if(res.data.code==0){
						this.loading = false;
						this.count = res.data.count
						if (res.data.data.length==0 || this.count === 0) {
						    // 加载结束
						    this.finished = true;
						    return;
						}
						
						this.personList = this.personList.concat(res.data.data)
						
						
						if (this.personList.length >= this.count) {
						    this.finished = true;
						}
					}
				})
			},
			// 点击添加
			addPerson(){
				console.log('kkk');
				this.$router.push(`/admin/personAdd`)
			},
			// 页面返回
			goto(){
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	.btnBox{
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}
	.personItem{
		display: flex;
		border-bottom: 1px solid #ccc;
		/* padding: 10px 0; */
	}
	.itemImg{
		width: 65px;
		height: 65px;
		border-radius: 50%;
		margin:0 20px 0 10px;
		display: flex;
		align-self: center;
	}
	.itemInfoBox{
		padding-top: 10px;
	}
	.itemInfo{
		font-size: 15px;
		display: flex;
		width: 200px;
	}
	.itemName{
		/* flex: 3; */
		display: flex;
		justify-content: flex-start;
	}
	.itemMobile{
		/* flex: 7; */
		display: flex;
		justify-content: flex-start;
	}
	.itemBtn{
		background-color: #1ABC9C;
		width: 60px;
		height: 35px;
		color: #fff;
		border-radius: 5px;
		line-height: 35px;
		text-align: center;
		margin: auto;
		font-size: 14px;
	}
	.itemBtnDel{
		background-color: #FF0000;
		width: 60px;
		height: 35px;
		color: #fff;
		border-radius: 5px;
		line-height: 35px;
		text-align: center;
		margin: auto;
		font-size: 14px;
	}
	.requist {
		width: 80%;
		margin: 0 auto;
		margin-top: 30px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-around;
	}
	
	.requist>>>.van-cell {
		width: 180px;
		border: 1px solid #ccc;
		padding: 4px 6px;
		border-radius: 4px;
	}
	.cents>>>.van-nav-bar__title{
		color: #fff;
	}
	.cents>>>.van-nav-bar .van-icon{
		color: #fff;
	}
	.cents>>>.van-nav-bar .van-nav-bar__text{
		color: #fff;
		font-size: 15px;
	}
</style>
